export default __webpack_public_path__ + "static/media/reclame_aqui.dd24dfdf.png";